import { type ReactNode, useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl-next';

import { useAuthData } from '../../utils/auth-context';

import { getMessagesForLocale } from './utils';

export const DevAgentIntlProvider = ({ children }: { children: ReactNode }) => {
	const [messages, setMessages] = useState<undefined | Record<string, string>>(undefined);
	const {
		user: { locale },
	} = useAuthData();

	useEffect(() => {
		const loadMessages = async () => {
			try {
				const translatedMessages: Record<string, string> | undefined = await getMessagesForLocale(
					(locale ?? 'en-us').toLowerCase(),
				);

				setMessages(translatedMessages);
			} catch (e) {
				console.error(`Failed to load messages for locale ${locale}. Falling back to default:`, e);
				setMessages(undefined);
			}
		};

		loadMessages();
	}, []);

	return (
		<IntlProvider locale={locale ?? 'en-US'} messages={messages || undefined}>
			{children}
		</IntlProvider>
	);
};
